var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.09C0 24.043 5.777 30.658 13.333 32V20.444h-4V16h4v-3.556c0-4 2.578-6.221 6.223-6.221 1.155 0 2.4.177 3.555.354v4.09h-2.044c-1.956 0-2.4.977-2.4 2.222V16h4.266l-.71 4.444h-3.556V32C26.223 30.659 32 24.045 32 16.09 32 7.24 24.8 0 16 0S0 7.24 0 16.09Z",
    fill: "#F7C144"
  })));
};

export default SvgFacebook;